module.exports = __webpack_public_path__ + "img/email_newletter.0c4b8f5a.png";